export const addActiveEtapa = activeEtapa => dispatch => {
  dispatch({ type: "ADD_ACTIVE_ETAPA", payload: { activeEtapa } });
};
